// extracted by mini-css-extract-plugin
export default {"subscrItems":"Subscriptions_subscrItems__SPjjo","button":"Subscriptions_button__J7ouE","preloader":"Subscriptions_preloader__CzXlt"};